export * from './MinusSmallIcon'
